import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { removeDeletedPipe, removeDeletedSystem } from '../redux-store/thunks/liveUpdates.thunks';
import { dirtyStateUpdated } from '../redux-store/thunks/editor.thunks';
import { toastAdded } from '../redux-store/thunks/global.thunks';
import useClipboard from '../hooks/useClipboard';

import { EntityDeletedMessage } from '../components/entity-deleted-message/EntityDeletedMessage.view';
import { EntityDeletedMessageCopyButton } from '../components/entity-deleted-message/EntityDeletedMessageCopyButton.view';

import type { RootState } from 'src/types/state.types';
import type { PipeConfig } from '../types/pipes.types';

export const EntityDeletedMessageContainer: React.FC<{
  gotoLink: string;
  pipeId?: string;
  systemId?: string;
  config?: PipeConfig;
  entityName: 'pipe' | 'system' | 'dataset';
}> = ({ pipeId, systemId, config, gotoLink, entityName }) => {
  const dispatch = useDispatch();
  const json = JSON.stringify(config, null, 2);
  const isDarkMode = useSelector((state: RootState) => state.theme.dark);

  const addToast = (message: string) => {
    dispatch(toastAdded({ message, type: 'success' }));
  };

  useClipboard('.dataset-inspector-viewer__entity-header-copy-button', () => {
    addToast('Copied to clipboard!');
  });

  useEffect(
    () => () => {
      pipeId
        ? dispatch(removeDeletedPipe(pipeId))
        : systemId
        ? dispatch(removeDeletedSystem(systemId))
        : undefined;

      dispatch(
        dirtyStateUpdated({
          isDirty: false,
          unsavedEditedConfig: undefined,
        })
      );
    },
    []
  );

  return (
    <EntityDeletedMessage
      entityId={pipeId || systemId || ''}
      gotoLink={gotoLink}
      json={json}
      isDarkMode={isDarkMode}
      copyButton={<EntityDeletedMessageCopyButton json={json} isDarkMode={isDarkMode} />}
      entityName={entityName}
    />
  );
};
